import React, { useRef } from "react";
import {
  FaCheckCircle,
  FaTimesCircle,
  FaExclamationTriangle,
} from "react-icons/fa";
import translations from "./translations.json";
import "./css/notification.css";

const NotificationPopover = ({ message, type, countdown }) => {
  const popoverRef = useRef(null);
  const lang = localStorage.getItem("preferredLanguage") || "nl";
  const t = translations[lang].notifications;

  const getIconAndColor = (type) => {
    switch (type) {
      case "success":
        return { icon: <FaCheckCircle />, color: "#4CAF50" };
      case "error":
        return { icon: <FaTimesCircle />, color: "#f44336" };
      case "warning":
        return { icon: <FaExclamationTriangle />, color: "#FFA500" };
      case "time":
        return { icon: <FaCheckCircle />, color: "#2196F3" };
      default:
        return { icon: <FaCheckCircle />, color: "#4CAF50" };
    }
  };

  const { icon, color } = getIconAndColor(type);
  const displayMessage =
    type === "time" && countdown > 0
      ? t.timePrefix.replace("{countdown}", countdown)
      : message;
  const text =
    typeof displayMessage === "object"
      ? JSON.stringify(displayMessage)
      : displayMessage;
  return (
    <div ref={popoverRef} className={`notification-popover ${type}`}>
      <div className="notification-icon" style={{ backgroundColor: color }}>
        {icon}
      </div>
      <span className="notification-message">{text}</span>
    </div>
  );
};

export default NotificationPopover;
